<div class="label-list-wrapper" [class.no-wrap]="multilineMode()">
  @for (
    tag of truncateLabels()
      ? (assignedTags() | slice: 0 : amountBeforeTruncation())
      : assignedTags();
    track tag
  ) {
    <app-label-list-tag
      [tag]="tag"
      [color]="tag.color"
      [name]="isSystemTag() ? tag : tag?.title"
      [isSystemTag]="isSystemTag()"
      [tagType]="isSystemTag() ? undefined : tag?.ownershipType"
      [readonly]="readonly()"
      (unassignTag)="onUnassignTag($event)"
    >
    </app-label-list-tag>
  }
  @if (truncateLabels() && assignedTags()?.length > amountBeforeTruncation()) {
    <div
      im-dropdown
      position="block-end"
      class="align-self-center me-2"
      (click)="$event.stopPropagation()"
    >
      <button imDropdownTrigger class="label-list__overflow-trigger">
        <app-badge class="c-pointer">
          ... {{ assignedTags()?.length - amountBeforeTruncation() }}
        </app-badge>
      </button>
      <div imDropdownMenu>
        <div class="label-list__overflow">
          @for (
            tag of assignedTags()
              | slice: amountBeforeTruncation() : assignedTags()?.length;
            track tag
          ) {
            <div class="label-list__overflow-entry">
              <app-label-list-tag
                [tag]="tag"
                [name]="isSystemTag() ? tag : tag?.title"
                [color]="tag?.color"
                [isSystemTag]="isSystemTag()"
                [tagOwnershipType]="tag?.ownershipType"
                [tagType]="isSystemTag() ? undefined : tag?.ownershipType"
                [readonly]="readonly()"
                (unassignTag)="unassignTag.emit($event)"
              >
              </app-label-list-tag>
            </div>
          }
        </div>
      </div>
    </div>
  }
  @if (!readonly() && assignableTags()?.length) {
    <div
      im-dropdown
      position="block-end"
      class="align-self-center"
      (click)="$event.stopPropagation()"
    >
      <!-- the tooltip sits beside the menu, not around it, so hovering the
      menu doesn't show it, and its position doesn't reach im-dropdown -->
      <span
        [imTooltip]="
          (isAddLabelObject()
            ? 'landlord.add_tag_object_tooltip_l'
            : 'property_searcher.add_tag_tooltip_l'
          ) | translate
        "
        [position]="tooltipPlacement()"
      >
        <button
          imDropdownTrigger
          class="add-tag__icon"
          [attr.aria-label]="
            (isAddLabelObject()
              ? 'landlord.add_tag_object_tooltip_l'
              : 'property_searcher.add_tag_tooltip_l'
            ) | translate
          "
        >
          <i class="icon icon--plus" style="font-size: 13px"></i>
        </button>
      </span>
      <div imDropdownMenu>
        <!-- no imDropdownItem: the menu stays open to assign several tags -->
        <div imDropdownGroup class="label-list__overflow">
          @for (tag of assignableTags(); track tag) {
            <button type="button" role="menuitem" (click)="onAssignTag(tag)">
              <app-tag
                class="labels-tag labels-tag--clickable"
                [name]="isSystemTag() ? tag : tag?.title"
                [color]="tag?.color"
                [isSystemTag]="isSystemTag()"
                [tagType]="isSystemTag() ? undefined : tag?.ownershipType"
              ></app-tag>
            </button>
          }
        </div>
      </div>
    </div>
  }
</div>
